import DataBreachesPendingReadModelRepresentation
  from '@/domain/dataBreach/pending/DataBreachesPendingReadModelRepresentation';

export default class DataBreachesPendingRepresentation
  extends DataBreachesPendingReadModelRepresentation {}
